<ul class="list">
  <ng-container *ngFor="let item of items">
    <li *ngIf="!item.isItemHidden"
        class="item"
        [class.item--size-sm]="item.itemSize === ItemSize.Small"
        [class.item--size-xs]="item.itemSize === ItemSize.ExtraSmall"
        [class.item--hide-divider]="item.hideDividerBelow"
        [class.item--info]="item.itemType === ItemType.Info">

      <ng-container [ngSwitch]="item.itemType">
        <ng-container *ngSwitchCase="ItemType.Custom">
              <ng-container *ngTemplateOutlet="
                  templateMap[item.customItemTemplateName];
                  context: { $implicit: item }
                "></ng-container>
        </ng-container>

        <ng-container *ngSwitchCase="ItemType.Info">
          <ng-container [ngSwitch]="item.valueData.optionType">
            <span *ngSwitchCase="OptionType.String"
                  class="info"
                  [innerHTML]="item.valueData.displayedValue | safePureHtml">
            </span>
            <a *ngSwitchCase="OptionType.RouterLink"
               class="link"
               (click)="onClickRouterLink(item.valueData)">
              {{ item.valueData?.displayedValue ?? item.valueData?.routerLink }}
            </a>
            <a *ngSwitchCase="OptionType.ExternalLink"
               rel="noopener"
               class="link"
               (click)="onClickExternalLink(item.valueData)">
              {{ item.valueData?.displayedValue ?? item.valueData?.externalLink }}
            </a>
            <ng-container *ngSwitchCase="OptionType.CustomTemplate">
              <ng-container *ngTemplateOutlet="
                  templateMap[item.valueData.customTemplateName];
                  context: { $implicit: item }
                "></ng-container>
            </ng-container>
          </ng-container>
        </ng-container>

        <ng-container *ngSwitchCase="ItemType.TitleValue">
          <div class="item-title"
               #titleEl
               [matTooltip]="item.titleData.tooltipMessage ?? item.titleData.displayedValue ?? item.titleData?.routerLink"
               [matTooltipDisabled]="!item.titleData.tooltipMessage && titleEl.scrollWidth <= titleEl.clientWidth"
               matTooltipShowDelay="200">
            <ng-container [ngSwitch]="item.titleData.optionType">
              <span *ngSwitchCase="OptionType.String"
                    class="item-title__string"
                    [innerHTML]="item.titleData.displayedValue | safePureHtml">
              </span>
              <a *ngSwitchCase="OptionType.RouterLink"
                 class="link"
                 (click)="onClickRouterLink(item.titleData)">
                {{ item.titleData.displayedValue ?? item.titleData?.routerLink}}
              </a>
              <a *ngSwitchCase="OptionType.ExternalLink"
                 rel="noopener"
                 class="link"
                 (click)="onClickExternalLink(item.titleData)">
                {{ item.titleData.displayedValue ?? item.titleData?.externalLink}}
              </a>
              <ng-container *ngSwitchCase="OptionType.CustomTemplate">
                <ng-container *ngTemplateOutlet="
                    templateMap[item.titleData.customTemplateName];
                    context: { $implicit: item }
                  "></ng-container>
              </ng-container>
            </ng-container>
          </div>
          <div class="item-value"
               *ngIf="item.valueData"
               #valueEl
               [class.item-value--hidden]="item.valueData.isOptionHidden"
               [matTooltip]="item.valueData.tooltipMessage ?? item.valueData.displayedValue ?? item.valueData?.routerLink"
               [matTooltipDisabled]="!item.valueData.tooltipMessage && valueEl.scrollWidth <= valueEl.clientWidth"
               matTooltipShowDelay="200">
            <ng-container [ngSwitch]="item.valueData.optionType">
              <span *ngSwitchCase="OptionType.String"
                    [innerHTML]="item.valueData.displayedValue | safePureHtml">
              </span>
              <a *ngSwitchCase="OptionType.RouterLink"
                 class="link"
                 (click)="onClickRouterLink(item.valueData)">
                {{ item.valueData.displayedValue ?? item.valueData?.routerLink }}
              </a>
              <a *ngSwitchCase="OptionType.ExternalLink"
                 rel="noopener"
                 class="link"
                 (click)="onClickExternalLink(item.valueData)">
                {{ item.valueData.displayedValue ?? item.valueData?.externalLink }}
              </a>
              <ng-container *ngSwitchCase="OptionType.CustomTemplate">
                <ng-container *ngTemplateOutlet="
                    templateMap[item.valueData.customTemplateName];
                    context: { $implicit: item }
                  "></ng-container>
              </ng-container>
            </ng-container>
          </div>
        </ng-container>
      </ng-container>
    </li>
  </ng-container>
</ul>
